import React, {useCallback, useContext, useEffect} from 'react';
import ENDPOINT from '../../../constants/endpoints';
import AsyncCardsSelect from '../../../GbsUI/components/AsyncCardsSelect';
import Button from '../../../GbsUI/UI/Button';
import ArrowLeftIcon from '../../../GbsUI/UI/icons/ArrowLeft';
import ArrowRightIcon from '../../../GbsUI/UI/icons/ArrowRight';
import SignupLayout from '../components/Layout';
import {SignupContext} from '../context';

const SignupSchool = ({history}) => {
  const {state, setState} =  useContext(SignupContext);

  const onContinue = useCallback(() => {
    history.push('/signup/step/1');
  }, [history]);

  useEffect(() => {
    if (state.flow === 'experienced-professional') {
      history.push('/signup/firm');
    }
  }, [history, state.flow]);

  return (
    <SignupLayout
      title={'Get Started: Share Your Undergrad School'}
      footer={
        <>
          <Button
            type={'button'}
            variant={'secondary'}
            size={'xl'}
            icon={ArrowLeftIcon}
            iconProps={{size: 21}}
            iconPosition={'left'}
            onClick={() => history.push('/signup')}
          >
            Back
          </Button>
          <Button
            size={'xl'}
            icon={ArrowRightIcon}
            iconProps={{size: 21}}
            iconPosition={'right'}
            disabled={!state?.education[0]?.school}
            onClick={onContinue}
          >
            Continue
          </Button>
        </>
      }
      stickyFooter
    >
      <AsyncCardsSelect
        selected={state?.education[0]?.school || null}
        onChange={(school) => {
          setState({
            ...state,
            education: [{
              ...(state.education[0] || {}),
              school
            }],
          });
        }}
        source={ENDPOINT.TAXONOMIES.SCHOOLS}
        notFoundText={'School is not found'}
        searchPlaceholder={'Enter your undergraduate university'}
        searchHelp={'Note: GoBuyside has no affiliation with these schools; names and logos are displayed for informational purposes and clarity.'}
      />
    </SignupLayout>
  )
}

export default SignupSchool
